import Proptypes from 'prop-types';

const DotNotificationBadge = ({ popoverText = '', className = '', showBadge, style = {} }) => {
  if (showBadge) {
    return (
      <span className={className} style={{ ...style }} title={popoverText}>
        <span className="circle-notification-badge" />
      </span>
    );
  }
  return null;
};

DotNotificationBadge.propTypes = {
  popoverText: Proptypes.string,
  showBadge: Proptypes.bool,
  className: Proptypes.string,
  style: Proptypes.object,
};

export default DotNotificationBadge;
